const backToTopButton = document.querySelector('.back-to-top');

if (backToTopButton) {
  connectedCallback()
}

function connectedCallback() {
  backToTopButton.addEventListener('click', this.onClick);
  window.addEventListener('scroll', this.checkVisible.bind(this));
}

function checkVisible(event) {
  window.requestAnimationFrame(() => {
    const pageHeight = window.innerHeight;
    let y = window.scrollY;
    if (y > pageHeight) {
      backToTopButton.classList.add('back-to-top--active');
    } else {
      backToTopButton.classList.remove('back-to-top--active');
    }
  });
}

function onClick() {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
}
